import { render, staticRenderFns } from "./tenantInstructionWrap.vue?vue&type=template&id=7df76c59&scoped=true&"
import script from "./tenantInstructionWrap.vue?vue&type=script&lang=js&"
export * from "./tenantInstructionWrap.vue?vue&type=script&lang=js&"
import style0 from "./tenantInstructionWrap.vue?vue&type=style&index=0&id=7df76c59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df76c59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7df76c59')) {
      api.createRecord('7df76c59', component.options)
    } else {
      api.reload('7df76c59', component.options)
    }
    module.hot.accept("./tenantInstructionWrap.vue?vue&type=template&id=7df76c59&scoped=true&", function () {
      api.rerender('7df76c59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantInstructionWrap.vue"
export default component.exports